import { WORKERDEMANDER_TYPES } from "../types";
import { WorkerDemanderService } from "../../services";

export const SaveWorkerDemanderForm = (
  newWorkDemander,
  setSubmitting,
  setProcessStatus
) => async (dispatch) => {
  setSubmitting(true);
  setProcessStatus(false);
  try {
    // 1 - Save Worker Demander
    const response = await WorkerDemanderService.SAVE_REQUEST_A_WORK(
      newWorkDemander
    );
    const { success, message } = await response.data;
    if (success) {
      const {data} = await response.data
     // console.log(1, response.data);
       dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_SUCCESS, payload: data });
    } else {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message });
     // console.log(2, message);
    }
    setSubmitting(false);
    setProcessStatus(true);
  } catch (error) {
    const { message, response } = error;
    if (response) {
      const { data } = response;
      if (data) {
        const rd =JSON.stringify(data);
      //  console.log(3, data);
        dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: rd });
      }
    } else {
      //console.log(4, message);
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  }
};


export const UpdateWorkRequestForm = (
  workerRequestId,
  newWorkerDemander,
  setSubmitting,
  setProcessStatus
) => async (dispatch) => {
  try {
    setSubmitting(true);
    setProcessStatus(false);
    const response = await WorkerDemanderService.UPDATE_WORK_REQUEST_ASYNC(
      workerRequestId,
      newWorkerDemander
    );
    const { success, message } = await response.data;
    if (success) {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_SUCCESS });
    } else {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message }); 
    }
    setSubmitting(false);
    setProcessStatus(true);
  } catch (error) {
    const { message, response } = error;
    if (response) {
      const { data } = response;
      if (data) {
        const rd =JSON.stringify(data);
        dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: rd });
      }
    } else {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  }
};

export const UpdateWorkerDemanderRegisterForm = (
  workerDemanderId,
  registeredBefore,
  newWorkerDemander,
  setSubmitting,
  setProcessStatus,
  resetForm
) => async (dispatch) => {
  try {
    console.log("genData1",newWorkerDemander);
    setSubmitting(true);
    setProcessStatus(false);
    var yy = [];
    newWorkerDemander.addressList.map((row) => yy.push({ ...row,id:0}));

    const genData = {...newWorkerDemander,addressList:yy}
     const response = await WorkerDemanderService.UPDATE_WORKER_DEMANDER_REGISTER_FORM( workerDemanderId, genData);
      const { success, message } = await response.data;
    if (!success) {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message });
    } else {
      if (!registeredBefore && newWorkerDemander.isRegistered) {
        const responseReg = await WorkerDemanderService.REGISTER_WORKERDEMANDER(workerDemanderId);
        const successReg = await responseReg.data.success;
        const messageReg = await responseReg.data.message;
        if (successReg) {
          dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_SUCCESS });
          resetForm();
        } else {
          dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: messageReg });
        }
      } else {
        dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_SUCCESS });
        resetForm();
      }
    }
    setSubmitting(false);
    setProcessStatus(true);
  } catch (error) {
    const { message, response } = error;
    if (response) {
      const { data } = response;
      if (data) {
        const rd =JSON.stringify(data);
        dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: rd });
      }
    } else {
      dispatch({ type: WORKERDEMANDER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  }
};

